/*
 * @Author: your name
 * @Date: 2019-12-11 21:29:44
 * @LastEditTime: 2020-03-18 23:11:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \周记 张经伟e:\gi劳务\src\router\modules\foremanHome.js
 */
const Home = () => import("@/views/home/index");//首页
const ForemanDetail = () => import("@/views/home/ForemanDetail");//工长详情
const AchievementDetail = () =>import('@/views/home/AchievementDetail');//业绩详情
const PersonPhoto = () =>import('@/views/home/PersonPhoto');//个人相册

// import PersonPhoto from '@/views/home/PersonPhoto';
import WorkerGroupRouter from './workerGroup'//工匠集群
import craftsmanInformationRouter from './craftsmanInformation'//工匠资讯
import creditEvaluationRouter from './creditEvaluation'//信用评价
import performanceDisplayRouter from './performanceDisplay'//展示类
import vcardRouter from './vcard'//电子名片

const homeRouter = [
  {
    path: "/home",
    component: Home,
    name: "home",
    meta: {
      name: '铭筑工匠',
      keepAlive: true,
    }
  },
  {
    path: '/foremanDetail/:id/:userId',
    name: 'foremanDetail',
    component: ForemanDetail,
    meta: {
      name: '工长详情',
      keepAlive: true,
    },
    // beforeEnter: (to, from, next)=> {
    //   if(from.name == 'personPhoto' || from.name == 'achievementDetail') {
    //     to.meta.keepAlive = true;
    //   }else {
    //     to.meta.keepAlive = false;
    //   }
    //   next();
    // }
  },
  {
    path: '/achievementDetail/:id',
    name: 'achievementDetail',
    component: AchievementDetail,
    meta: {
      name: '业绩详情'
    }
  },
  {
    path: '/personPhoto/:id',
    name: 'personPhoto',
    component: PersonPhoto,
    meta: {
      name: '个人相册'
    }
  }
];
export default homeRouter.concat(WorkerGroupRouter,craftsmanInformationRouter,creditEvaluationRouter,performanceDisplayRouter,vcardRouter);


// WEBPACK FOOTER //
// ./src/router/modules/home.js